<ng-container [formGroup]="accountDetailForm">
  <div class="input-group">
    <mat-form-field [color]="'accent'" [appearance]="matFormFieldAppearance">
      <mat-label class="account-detail-form-label">{{
        'redeem_cash_v2.link_account_form.first_name' | translate
      }}</mat-label>
      <input
        class="account-first-name-input"
        matInput
        type="text"
        formControlName="accountFirstName" />
      <mat-error
        aria-live="polite"
        class="account-first-name-empty"
        *ngIf="isAccountFirstNameEmpty">
        {{
          'redeem_cash_v2.link_account_form.error.first_name_empty' | translate
        }}
      </mat-error>
      <mat-error
        aria-live="polite"
        class="account-first-name-invalid"
        *ngIf="isAccountFirstNameInvalidPattern">
        {{
          'redeem_cash_v2.link_account_form.error.first_name_invalid_pattern'
            | translate
        }}
      </mat-error>
    </mat-form-field>
  </div>

  <div class="input-group">
    <mat-form-field [color]="'accent'" [appearance]="matFormFieldAppearance">
      <mat-label class="account-detail-form-label">{{
        'redeem_cash_v2.link_account_form.last_name' | translate
      }}</mat-label>
      <input
        class="account-last-name-input"
        matInput
        type="text"
        formControlName="accountLastName" />
      <mat-error
        aria-live="polite"
        class="account-last-name-empty"
        *ngIf="isAccountLastNameEmpty">
        {{
          'redeem_cash_v2.link_account_form.error.last_name_empty' | translate
        }}
      </mat-error>
      <mat-error
        aria-live="polite"
        class="account-last-name-invalid"
        *ngIf="isAccountLastNameInvalidPattern">
        {{
          'redeem_cash_v2.link_account_form.error.last_name_invalid_pattern'
            | translate
        }}
      </mat-error>
    </mat-form-field>
  </div>

  <div class="input-group">
    <mat-form-field [color]="'accent'" [appearance]="matFormFieldAppearance">
      <mat-label class="account-detail-form-label">{{
        'redeem_cash_v2.link_account_form.bsb_number' | translate
      }}</mat-label>
      <input
        class="bsb-number-input"
        matInput
        type="text"
        formControlName="bsbNumber" />
      <mat-error
        aria-live="polite"
        class="bsb-number-empty"
        *ngIf="isBsbNumberEmpty">
        {{
          'redeem_cash_v2.link_account_form.error.bsb_number_empty' | translate
        }}
      </mat-error>
      <mat-error
        aria-live="polite"
        class="bsb-number-invalid"
        *ngIf="isBsbNumberInvalidPattern">
        {{
          'redeem_cash_v2.link_account_form.error.bsb_number_invalid_pattern'
            | translate
        }}
      </mat-error>
    </mat-form-field>
  </div>

  <div class="input-group">
    <mat-form-field [color]="'accent'" [appearance]="matFormFieldAppearance">
      <mat-label class="account-detail-form-label">{{
        'redeem_cash_v2.link_account_form.account_number' | translate
      }}</mat-label>
      <input
        class="account-number-input"
        matInput
        type="text"
        formControlName="accountNumber" />
      <mat-error
        aria-live="polite"
        class="account-number-empty"
        *ngIf="isAccountNumberEmpty">
        {{
          'redeem_cash_v2.link_account_form.error.account_number_empty'
            | translate
        }}
      </mat-error>
      <mat-error
        aria-live="polite"
        class="account-number-invalid"
        *ngIf="isAccountNumberInvalidPattern">
        {{
          'redeem_cash_v2.link_account_form.error.account_number_invalid_pattern'
            | translate
        }}
      </mat-error>
    </mat-form-field>
  </div>

  <div
    class="account-form-helper-message"
    [innerHtml]="'redeem_cash_v2.link_account_form.helper' | translate"></div>
</ng-container>
